import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { HttpBackend } from '@angular/common/http';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class HelpCfg {
  public link: string;
}

@Injectable({
  providedIn: 'root'
})
export class HelpCfgService extends CfgService<HelpCfg> {
  json: any = {
    link: "%{HelpFrontUrl}",
    urlNoveltiesHistoric: "%{DashboardApiUrl}/novelties/historic?companyId={companyId}",
    urlNoveltyAttachment: "%{DashboardApiUrl}/novelty/download/{noveltyId}"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/help.cfg.json`;
  }

  /**
 * Carga las url en el json
 */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
